import { AxiosPromise } from "axios";
import { request } from "./request";

export const eventApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      // url: `/content/dropdown/events`,
      url: `/e-waiver/events/dropdown`,
      method: "get",
      params,
    }),
};
